import ANALITYCS_CATEGORY from '../category.json';

export default {
  ERROR_SCREEN: {
    action: 'error_screen',
    label: 'SCN:Erro',
    category: ANALITYCS_CATEGORY.ERROS,
  },
};
